export enum ChangeState {
  READY_FOR_TEST = 'ready_for_test',
  PENDING_APPLICATION = 'pending_application',
  REJECTED = 'rejected',
  ACCEPTED = 'accepted',
  APPLYING = 'applying',
}
